import type { TextInputProps, TextStyle } from 'react-native';

/** Locale controls alignment; structured values retain their reading order. */
export function inputDirectionStyle(isRTL: boolean, props: TextInputProps): TextStyle {
  const structured = props.secureTextEntry ||
    ['email-address', 'url', 'phone-pad', 'number-pad', 'decimal-pad', 'numeric', 'ascii-capable-number-pad'].includes(props.keyboardType ?? '') ||
    ['email', 'url', 'tel', 'numeric', 'decimal'].includes(props.inputMode ?? '') ||
    ['emailAddress', 'URL', 'telephoneNumber', 'oneTimeCode', 'username', 'password', 'newPassword'].includes(props.textContentType ?? '') ||
    ['email', 'url', 'tel', 'tel-national', 'tel-country-code', 'one-time-code', 'sms-otp', 'username', 'current-password', 'new-password'].includes(props.autoComplete ?? '');
  return {
    textAlign: isRTL ? 'right' : 'left',
    writingDirection: structured ? 'ltr' : 'auto',
  };
}
